var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-template',[_c('project-video',{attrs:{"size":"100","videoID":"348075034"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }